function makeEntry(keyFn, valueFn, element) {
    return [keyFn(element), valueFn(element)];
}
export function objectify(keyFn, valueFn, list) {
    var entries = list.map(function (element) { return makeEntry(keyFn, valueFn, element); });
    return Object.fromEntries(entries);
}
